<template>
  <el-button v-if="isShow" type="primary" class="export-lecto-btn" size="medium" @click="exportModule">导入当前模型</el-button>
</template>

<script>
import {WinForm,AppName} from '@digital-supply-chain/module'
import {DomainService} from '@/libs/api'

export default {
  props: {
    productDetail: { default: {} },
  },
  data() {
    return {}
  },
  computed: {
    isShow() {
      return WinForm.md.getAppName() === AppName.GreatIM && (this.productDetail.CompID == 0);
    }
  },
  methods: {
    exportModule() {
      const tabid = `standard_add_${this.productDetail.ProdID}`;
      const url = `${DomainService.ZPChainWorkerWeb}/#/product-standard-edit?id=0&standardid=${this.productDetail.ProdID}&tabid=${tabid}`;
      WinForm.md.openTab(url, undefined, '', tabid, false, true);
      setTimeout(() => {
        WinForm.md.closeTab(this.$route.query.tabid);
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.export-lecto-btn{
  position: fixed;
  right: 0;
  bottom: 0;
  text-align: center;
  z-index: 99;
  width: 146px;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}
</style>
